// extracted by mini-css-extract-plugin
export default {"label":"ChangePasswordModal_label__nh+E9","para":"ChangePasswordModal_para__N1qDI","forgetPassword":"ChangePasswordModal_forgetPassword__f8bit"};